import GemIcon from '../Idle/GemIcon';
import { useIdle } from '../../lib/idle/idleStore';
import Styles from './CosmeticsUnit.module.css';

const CosmeticsUnit = ({ className = '', title, data, selectedItem, handleClick }) => {
  const gems = useIdle((s) => s.gems);

  // data is an array at first and becomes an object once something is bought, so go through the keys
  const entries = Object.keys(data).map((key, index) => ({ key, index, obj: data[key] }));

  return (
    <section className={`${Styles.unit} ${className}`}>
      <h2 className={Styles.heading}>{title}</h2>

      <div className={Styles.cards}>
        {entries.map(({ key, index, obj }) => {
          const selected = obj.isOwned && selectedItem === index;
          const canAfford = gems >= obj.price;

          return (
            <button
              key={key}
              type="button"
              className={`${Styles.card} ${selected ? Styles.cardOn : ''}`}
              onClick={() => handleClick(title, key, index, obj)}
              aria-pressed={selected}
            >
              <span className={Styles.name}>{obj.title}</span>

              <span className={Styles.imageBox}>
                <img className={Styles.image} src={obj.image} alt="" draggable={false} />
              </span>

              <span className={Styles.foot}>
                {obj.isOwned ? (
                  <span className={selected ? Styles.selected : Styles.owned}>
                    {selected ? 'Selected' : 'Select'}
                  </span>
                ) : (
                  <span className={`${Styles.price} ${canAfford ? '' : Styles.broke}`}>
                    {obj.price}
                    <GemIcon size={26} />
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default CosmeticsUnit;